import React from 'react'

import {
  BackOutline,
  CustomLink,
  CustomAccordionDiv,
  CustomSubtitle,
} from '../Utils/CustomClasses'

import { Accordion, AccordionSummary, AccordionDetails } from '@mui/material'

// import { Container } from './styles';

export const BackButton = ({ link, text }) => {
  return (
    <CustomLink to={link}>
      <BackOutline>
        <a>{text}</a>
      </BackOutline>
    </CustomLink>
  )
}

export const CustomAccordion = ({ title, children }) => {
  return (
    <CustomAccordionDiv>
      <Accordion>
        <AccordionSummary
          expandIcon={<img src="/images/icons/accordion-icon.svg" />}
          aria-controls="panel1-content"
          id="panel1-header"
        >
          <CustomSubtitle bold size="22px">
            {title}
          </CustomSubtitle>
        </AccordionSummary>
        <AccordionDetails>
          <CustomSubtitle
            size="18px"
            dangerouslySetInnerHTML={{ __html: children }}
          />
        </AccordionDetails>
      </Accordion>
    </CustomAccordionDiv>
  )
}
